// extracted by mini-css-extract-plugin
export default {"copy":"oga-z","linkButton":"pga-z"};